import BaseService from "./base.service";
import { Singleton } from "util";
import { ApiResourceBuilder } from "core/builder";

@Singleton
export default class CategoryService extends BaseService {
  async fetch(companyUuid, { order, pagination, filters }) {
    const url = `/v1/companies/${companyUuid}/categories`;
    const resourceRoute = ApiResourceBuilder.buildFromParams(url, {
      order,
      pagination,
      filters
    });
    return await this.get(resourceRoute);
  }

  async fetchByUuid(companyUuid, categoryUuid) {
    return await this.get(
      `/v1/companies/${companyUuid}/categories/${categoryUuid}`
    );
  }

  async create(companyUuid, params) {
    return await this.post(`/v1/companies/${companyUuid}/categories`, params);
  }

  async update(companyUuid, uuid, params) {
    return await super.update(
      `/v1/companies/${companyUuid}/categories/${uuid}`,
      params
    );
  }

  async delete(companyUuid, uuid, params) {
    const query = params.children ? `?children=${params.children}` : "";
    return await this.destroy(
      `/v1/companies/${companyUuid}/categories/${uuid}${query}`
    );
  }

  // =================== LEGACY

  async updateCategory(companyUuid, categoryUuid, params) {
    params = {
      category: params
    };
    return await this.update(
      `/v1/companies/${companyUuid}/categories/${categoryUuid}`,
      params
    );
  }

  async createCategory(companyUuid, params) {
    return await this.post(`/v1/companies/${companyUuid}/categories`, params);
  }

  async deleteCategory(companyUuid, categoryUuid) {
    return await this.destroy(
      `/v1/companies/${companyUuid}/categories/${categoryUuid}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/service/category.service.js